import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from './api';

export const useSubscriptionFeatures = () => {
  const [subscriptionFeatures, setSubscriptionFeatures] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeatures = async () => {
      try {
        const response = await axios.get(`${API}/admin/organisation`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        setSubscriptionFeatures(response.data.subscription_features || {});
      } catch (error) {
        console.error('Failed to fetch subscription features:', error);
        setSubscriptionFeatures({});
      } finally {
        setLoading(false);
      }
    };

    fetchFeatures();
  }, []);

  return { subscriptionFeatures, loading };
};
